import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export var ButtonType;
(function (ButtonType) {
    ButtonType["IMPORTANT"] = "important";
    ButtonType["ALTERNATIVE"] = "alternative";
})(ButtonType || (ButtonType = {}));
const ButtonComponent = (props) => {
    var _a, _b;
    return (React.createElement("button", { disabled: props.disabled, "data-testid": props.dataTestId, className: `submit-button ${props.disabled ? 'disabled' : ''} ${props.type ? props.type : ButtonType.IMPORTANT}  ${(_a = props.additionalClass) !== null && _a !== void 0 ? _a : ''} ${(_b = props.height) !== null && _b !== void 0 ? _b : 'medium'}`, onClick: props.onClick },
        React.createElement("div", { className: "button-label" },
            props.skipLabelTranslation
                ? props.label
                : getMessage(props.label, props.labelParams),
            ' '),
        props.logo && React.createElement(SVGIcon, { icon: props.logo, className: "logo" })));
};
export default ButtonComponent;
